/**
 * Shared constants
 */

export const DEFAULT_AGENT_TEMPERATURE = 0.0;

export const DEFAULT_OUTPUT_SCHEMA_TEXT = `{
  "type": "object",
  "properties": {
    "classification": {"type": "string"},
    "confidence": {"type": "number"},
    "reasoning": {"type": "string"}
  },
  "required": ["classification", "confidence"]
}`;
